"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateFunction = exports.dayShort = exports.dayNames = exports.monthShort = exports.monthNames = exports.dateTimeFormat = void 0;
const numberFormatPad_1 = require("./numberFormatPad");
/**
 * formatuje datę i czas do formatu yyyy-MM-dd HH:mm:ss
 * @param dt data typu Date
 */
function dateTimeFormat(dt, format) {
    return exports.formatDateFunction[format || 'yyyy-MM-dd HH:mm:ss'](dt);
}
exports.dateTimeFormat = dateTimeFormat;
exports.monthNames = [
    'styczeń',
    'luty',
    'marzec',
    'kwiecień',
    'maj',
    'czerwiec',
    'lipiec',
    'sierpień',
    'wrzesień',
    'październik',
    'listopad',
    'grudzień'
];
exports.monthShort = [
    'sty',
    'lut',
    'mar',
    'kwi',
    'maj',
    'cze',
    'lip',
    'sie',
    'wrz',
    'paź',
    'lis',
    'gru'
];
exports.dayNames = ['poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota', 'niedziela'];
const dayNames2 = ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'];
exports.dayShort = ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'N'];
const dayShort2 = ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'N'];
exports.formatDateFunction = {
    'dd.MM.yyyy': (dt) => (0, numberFormatPad_1.numberFormatPad)(dt.getDate()) + '.' + (0, numberFormatPad_1.numberFormatPad)(dt.getMonth() + 1) + '.' + dt.getFullYear(),
    'yyyy-MM-dd': (dt) => dt.getFullYear() + '-' + (0, numberFormatPad_1.numberFormatPad)(dt.getMonth() + 1) + '-' + (0, numberFormatPad_1.numberFormatPad)(dt.getDate()),
    'MMMM yyyy': (dt) => `${exports.monthNames[dt.getMonth()]} ${dt.getFullYear()}`,
    'MMM yyyy': (dt) => `${exports.monthShort[dt.getMonth()]} ${dt.getFullYear()}`,
    dddd: (dt) => dayNames2[dt.getDay()],
    ddd: (dt) => dayShort2[dt.getDay()],
    dd: (dt) => (0, numberFormatPad_1.numberFormatPad)(dt.getDate()),
    d: (dt) => dt.getDate().toString(),
    MMMM: (dt) => exports.monthNames[dt.getMonth()],
    MMM: (dt) => exports.monthShort[dt.getMonth()],
    MM: (dt) => (0, numberFormatPad_1.numberFormatPad)(dt.getMonth() + 1),
    M: (dt) => (dt.getMonth() + 1).toString(),
    HH: (dt) => (0, numberFormatPad_1.numberFormatPad)(dt.getHours()),
    H: (dt) => dt.getHours().toString(),
    mm: (dt) => (0, numberFormatPad_1.numberFormatPad)(dt.getMinutes()),
    m: (dt) => dt.getMinutes().toString(),
    ss: (dt) => (0, numberFormatPad_1.numberFormatPad)(dt.getSeconds()),
    s: (dt) => dt.getSeconds().toString(),
    'HH:mm:ss': (dt) => `${(0, numberFormatPad_1.numberFormatPad)(dt.getHours())}:${(0, numberFormatPad_1.numberFormatPad)(dt.getMinutes())}:${(0, numberFormatPad_1.numberFormatPad)(dt.getSeconds())}`,
    'dd.MM.yyyy HH:mm:ss': (dt) => exports.formatDateFunction['dd.MM.yyyy'](dt) + ' ' + exports.formatDateFunction['HH:mm:ss'](dt),
    'yyyy-MM-dd HH:mm:ss': (dt) => exports.formatDateFunction['yyyy-MM-dd'](dt) + ' ' + exports.formatDateFunction['HH:mm:ss'](dt)
};
//# sourceMappingURL=dateTimeFormat.js.map